// TODO: Deprecate JS logic on the Advanced Search Page 
//		 Instead, use standard HTML forms to submit advanced 
//		 search queries. Presentation JS should be moved to 
//		 other global script files and any advancedsearch.js
//		 files should be deleted.


// Advanced Search
// ========================================

var SCM = SCM || {};

SCM.AdvancedSearch = {};

SCM.AdvancedSearch.configSettings = {
    preSelectSingleBookFacet: 'true'
};


// ----
// Global Variables
// ----

var textCharectorLimit = $('.hfSolrMaxAllowSearchChar').val(); // hidden field on the master page of the client
var UrlStripTrailingCharactersPattern = '^.*[/\\\\]$'; //match  ending characters "\" or "/"

// ----
// Add Subscription Parameter to URL
// ----

function AppendSubscriptionParameterToUrl(redirectUrl) {
    var subOnlyParam = '&subonly=true';
    var url = redirectUrl;
    var isSubOnly = false;
    if ($('#hfEnableSubscriptionFilter').length) {
        isSubOnly = $('#hfEnableSubscriptionFilter').val().toLowerCase() == 'true';
    }
    // check for subscription only value
    if (isSubOnly) {
        // add the subscription parameter to the URL
        url = redirectUrl + subOnlyParam;
    }

    return url;
}

function StripTrailingCharacters(stringToStripCharacters, regexTrailingCharactersPattern) {
    var regex = new RegExp(regexTrailingCharactersPattern);

    //remove all trailing characters
    while (regex.test(stringToStripCharacters)) {
        stringToStripCharacters = stringToStripCharacters.substring(0, stringToStripCharacters.length - 1);
    }
    return stringToStripCharacters;
}

// ----
// Date
// ----

//For todays date;
// Source: http://stackoverflow.com/questions/10211145/getting-current-date-and-time-in-javascript
Date.prototype.today = function () {
    return (this.getMonth() + 1 < 10 ? '0' : '') + (this.getMonth() + 1) + '/' + (this.getDate() < 10 ? '0' : '') + this.getDate() + '/' + this.getFullYear();
};

// set the character limit if none is already set
if (textCharectorLimit == null || textCharectorLimit == '') {
    textCharectorLimit = '255';
}

// compose a valid date
function isValidDate(date) {
    var matches = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(date);
    if (matches == null) return false;
    var d = matches[2];
    var m = matches[1] - 1;
    var y = matches[3];
    var composedDate = new Date(y, m, d);
    return composedDate.getDate() == d &&
            composedDate.getMonth() == m &&
            composedDate.getFullYear() == y;
}

// check if its only a year
function isYearOnly(date) {
    var matches = /^(\d{4})$/.exec(date);

    return matches && matches[1] > -1;
}

// change year only entrees to full formed dates
function updateYearOnlyToFullDate(dateTxtField, isStartDate) {
    var year = dateTxtField.val();
    var month = null;
    var day = null;
    if (isStartDate) {
        month = '01';
        day = '01';
    } else {
        month = '12';
        day = '31';
    }

    dateTxtField.val(month + '/' + day + '/' + year);

    return dateTxtField.val();
}

// Today's date as YYYY-MM-DD (local), matching the value format of a native <input type="date">.
function isoToday() {
    var now = new Date();
    var month = ('0' + (now.getMonth() + 1)).slice(-2);
    var day = ('0' + now.getDate()).slice(-2);
    return now.getFullYear() + '-' + month + '-' + day;
}

//Restore the AdvancedQueryBuilder to previous state 
function restoreQbData() {
    if (!sessionStorage)
        return;
    var htmlJsonString = sessionStorage.getItem('querybuilder_html');
    if (!htmlJsonString)
        return null;
    var qbHtml = JSON.parse(htmlJsonString);
    $('#queryBuilder').html(qbHtml);
}

// ----
// Set Search Scope
// ----

var micrositeJournalDisplayName = '';
var micrositeJournalId = '';
var solrsearchScope = $('.hfSolrJournalID').val();
var solrBookSearchScope = $('#hfSolrBookID').val();

// TODO: Handle undefined scope

if (typeof solrsearchScope === 'undefined') {
    solrsearchScope = ''; //default it to empty string
} else {
    if (solrsearchScope != null) {
        solrsearchScope = solrsearchScope.replace('J', '');
    }
}

if (typeof solrBookSearchScope === 'undefined') {
    solrBookSearchScope = ''; //default it to empty string
} else {
    if (solrBookSearchScope != null) {
        solrBookSearchScope = solrBookSearchScope.replace('B', '');
    }
}

function GetQueryStringCharacter(queryString) {
    if (queryString.includes('?')) {
        return '&';
    }

    return '?';
}

function AddQueryStringParams(queryString) {

    var contentOwned = $('.access-filter-input-radio[value=contentowned]').is(':checked');
    if (contentOwned) {
        queryString = queryString + GetQueryStringCharacter(queryString) + 'access_openaccess=true&access_free=true&access_unlocked=true';
    }

    var contentTypeFilter = '';
    $('#advancedSearch .advanced-search-content-type:checked').each(function () {
        if (this.checked) {
            if (!contentTypeFilter) {
                contentTypeFilter = $(this).attr('value');
            } else if (contentTypeFilter.length > 0) {
                contentTypeFilter += ' OR ' + $(this).attr('value');
            }
        }
    });

    if (contentTypeFilter) {
        queryString = queryString + GetQueryStringCharacter(queryString) + 'fl_ContentType=' + contentTypeFilter;
    }

    return queryString;
}

$(document).ready(function () {


    // ----
    // Check Boxes
    // ----

    // if not looking for books
    if (solrBookSearchScope == null || solrBookSearchScope == '') {

        // 1) disable all books check boxes
        $('#advancedSearch input.advancedSearchBook[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });

        $('.advancedAuthorSearch input.advancedSearchBook[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });


        // 2) uncheck books radio button 
        $('input.rbPublication[type=radio]').each(function () {
            var isAllBooks = $(this).attr('value') == 'B*' ? true : false;
            if (isAllBooks) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });

    } else {
        // it is a book search so.. disable journal stuff

        //1) check boxes
        $('#advancedSearch input.advancedSearchJournal[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });

        $('.advancedAuthorSearch input.advancedSearchJournal[type=checkbox]').each(function () {
            $(this).prop('checked', false);
            $(this).prop('disabled', true);
        });


        // 2) uncheck books radio button 
        $('input.rbPublication[type=radio]').each(function () {
            var isAllJournals = $(this).attr('value') == 'J*' ? true : false;
            if (isAllJournals) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });
    }


    // preselect the journal for check box and drop down.
    if (solrsearchScope != null && solrsearchScope != '' || solrBookSearchScope != null && solrBookSearchScope != '') {
        $('.advancedAuthorSearch input:checkbox').each(function () {
            var currentDisplayName = $(this).attr('currentjournaldisplayname');
            var currentText = $(this).attr('text');
            var journalId = $(this).attr('jid');
            var bookId = $(this).attr('bid');
            if (currentDisplayName != null & currentText != null && currentDisplayName == currentText) {
                if (journalId == solrsearchScope) {
                    // alert(journalId);
                    this.checked = true;

                    //get the journal display Name for the microsite journal.
                    micrositeJournalDisplayName = currentText;
                    micrositeJournalId = journalId;

                    //exit loop
                    return false;
                }
            } else if (bookId != null && bookId != '') {
                if (bookId == solrBookSearchScope || solrBookSearchScope === '*') {
                    this.checked = true;
                }
            }
        });

        $('#advancedSearch input:checkbox').each(function () {
            var currentDisplayName = $(this).attr('currentjournaldisplayname');
            var currentText = $(this).attr('text');
            var journalId = $(this).attr('jid');
            var bookId = $(this).attr('bid');

            if (currentDisplayName != null & currentText != null && currentDisplayName == currentText) {
                if (journalId == solrsearchScope) {
                    // alert(journalId);
                    this.checked = true;

                    //get the journal display Name for the microsite journal.
                    micrositeJournalDisplayName = currentText;
                    micrositeJournalId = journalId;

                    //exit loop
                    return false;
                }
            } else if (bookId != null && bookId != '') {
                //alert('Book ID in advancedSearch is ::' + bookId);
                if (bookId == solrBookSearchScope || solrBookSearchScope === '*') {
                    this.checked = true;
                }
            }
        });

        $('.citationJournal').each(function () {
            $('option', this).each(function () {
                var jarrayItemValue = $(this).val().split(',');
                if (jarrayItemValue != null && jarrayItemValue[0] == 'C') {
                    var journalId = jarrayItemValue[1];
                    if (journalId == solrsearchScope) {
                        // alert(journalId);
                        $(this).prop('selected', true);
                    }
                }
            });
        });

    }

    // ----
    // Title Search
    // ----

    //Title Search function used for the button click and Default behavior of the Title text field.
    function doTitleSearch(title) {

        if (title == null || title == '') {
            alert('Please enter a term to search');
            return;
        } else if (title.length > parseInt(textCharectorLimit)) {
            alert('Please enter a term between 1 to ' + textCharectorLimit + ' characters');
            return;
        } else {

            var articleTitle = '"' + title + '"';
            var targetUrl = '';
            var journalQuery = '';

            if (solrsearchScope) {
                journalQuery = '&fl_JournalID=' + micrositeJournalId + '&f_JournalDisplayName=' + encodeURIComponent($.trim(micrositeJournalDisplayName));
            }

            targetUrl = '/search-results?q=' + encodeURIComponent(articleTitle) + '&fd_ArticleTitle=' + encodeURIComponent(articleTitle);//+ "&exPrm_qqq=" + encodeURIComponent("{!payload_score f=Tags func=max v=q$}" + wildCardCharacter);

            if (journalQuery != '') {
                //append journalID and JournalDisplayName querystrings to the url.
                targetUrl = targetUrl + journalQuery;
            } else {
                //ToDo: Check if this is necessary.
                targetUrl = targetUrl + '&allJournals=1';
            }

            targetUrl = AppendSubscriptionParameterToUrl(targetUrl);

            var searchSiteUrl = StripTrailingCharacters($('#hfSiteURL').val(), UrlStripTrailingCharactersPattern);
            window.location.href = window.location.protocol + '//' + searchSiteUrl + targetUrl + '&searchType=advanced';
        }
    }

    $('#btnAdvancedTitleSearch').click(function () {
        var searchTerm = $('#articleTitle').val();
        doTitleSearch(searchTerm);
    });

    $('#articleTitle').keydown(function (e) {
        if (e.keyCode == 13) {
            var searchTerm = $('#articleTitle').val();
            //alert(searchTerm);

            doTitleSearch(searchTerm);
        }
    });

    // ----
    // Citation Search
    // ----

    //Citation Search
    function doAdvancedCitationSearch() {

        var ctYearValue = $('#citationYear').val();
        var ctVolumeValue = $('#citationVolume').val();
        var volumePattern = $('#citationVolume').attr('pattern');
        var ctStartPageValue = $('#citationPage').val();
        var ctJournalValue = $('.citationJournal').val();
        var journalDisplayName = $('.citationJournal option:selected').text();
        var isCurrentJournal = false;

        var ctIssueNoValue = '';
        if ($('#citationIssueNo').length) {
            ctIssueNoValue = $('#citationIssueNo').val();
        }

        var citationData = {};
        var validationMessage = '';

        if (ctJournalValue == null || ctJournalValue == '' || ctJournalValue == '- Select a Journal') {
            validationMessage = 'Please select a journal.' + '\n';
        }

        //YEAR
        if (ctYearValue != null && ctYearValue != '' && ctYearValue != 'Yr') {
            if (isNaN(ctYearValue)) {
                validationMessage = validationMessage + 'Year must be numeric.' + '\n';
            } else {
                //var rangequery = ctYearValue + "-01-01T00:00:00.000Z TO " + ctYearValue + "-12-31T23:59:59.000Z";
                //Instead of using the ISO format, just using the MM/DD/YYYY format
                var rangequery = '01/01/' + ctYearValue + ' TO ' + '12/31/' + ctYearValue;
                citationData.rg_PublicationDate = rangequery;
            }
        }


        //VOLUME
        if (ctVolumeValue != null && ctVolumeValue != '' && ctVolumeValue != 'Vol') {
            var volumeRegex = new RegExp(volumePattern);
            if (volumeRegex.test(ctVolumeValue)) {
                citationData.fd_Volume = ctVolumeValue;
            } else {
                validationMessage = validationMessage + 'Volume must be alphanumeric without spaces';
            }
        }

        if (ctIssueNoValue !== null && ctIssueNoValue !== '' && ctIssueNoValue !== 'Issue') {
            citationData.fd_IssueNo = ctIssueNoValue;
        }

        if (ctStartPageValue != '' && ctStartPageValue != '1st Pg') {
            citationData.fd_StartPage = ctStartPageValue;
        }

        if (validationMessage.length > 0) {
            //validation failed!
            alert(validationMessage);
            return false;
        }

        //CSV will contain 3 elements: First element will be either "C" (current journal) or "L" (legacy journal);Second element will be the JournalID;Third element will be JournalHistoricalAttributesID
        var jarray = ctJournalValue.split(',');
        if (jarray[0] == 'C') {
            //Current Journal: Results should include all articles from current journal and all the legacy journals associated with it.
            //Pass just the JournalID
            citationData.fl_JournalID = jarray[1];
            isCurrentJournal = true;

        } else {
            //Legacy: Results should include only articles published under this legacy journal name.
            //Pass the LegacyHistID to get accurate results.
            citationData.fl_JournalHistID = jarray[2];
        }

        //Pass Journal Display Name so Journal is preselected on the results page and ArticleClientType facet (dependent on JournalDisplayName) is displayed!
        //Encode the JournalDisplayName to make sure DisplayNames which have "&" or "-" or other characters are intrepreted correctly.

        //Add Relevancy Parameter
        //var wildCardCharacter = "\"" + "*:*" + "\"";
        //citationData.exPrm_qqq = "{!payload_score f=Tags func=max v=q$}" + wildCardCharacter;

        var redirectUrl = '/search-results?' + $.param(citationData);

        //$.param() encodes every value it serializes; never pre-encode values placed in the data object.
        //journalFacetName is concatenated after $.param, so it is the one value encoded by hand.
        //ToDo:Because the Journal list includes legacy journals, when a legacy journal is selected, ArticleClientType facet will not be displayed because the ArticleClientType facet depends on JournalDisplayName and not LegacyJournalDisplayName.
        var journalFacetName = '';  //encodeURIComponent($.trim(journalDisplayName));
        if (isCurrentJournal) {
            journalFacetName = '&f_JournalDisplayName=' + encodeURIComponent($.trim(journalDisplayName));
        } else {
            //ToDo:Revisit this!
            //We can certainly make "LegacyJournalDisplayName" a facet and then create a dependency between LegacyJournalDisplayName & ArticleClientType but
            journalFacetName = '&fd_LegacyJournalDisplayName=' + encodeURIComponent($.trim(journalDisplayName));
        }

        redirectUrl = redirectUrl + journalFacetName;

        var searchSiteUrl = StripTrailingCharacters($('#hfSiteURL').val(), UrlStripTrailingCharactersPattern);
        window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&searchType=advanced';
        return false;
    }

    //Citation Search Click
    $('#btnAdvancedCitationSearch').click(function () {
        doAdvancedCitationSearch();
    });

    //Enter key -- Advanced Citation Search
    $('#btnAdvancedCitationSearch').keyup(function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            doAdvancedCitationSerach();
        }
    });

    // ----
    // Keyword Search
    // ----

    //KeyWord Search
    function doAdvancedKeyWordSearch() {
        // alert("hello");
        var radioCheck = '1';
        var startDate = null;
        var endDate = null;
        var searchTerm = null;
        var journalIds = [];
        var bookIds = [];
        var journalHistIds = [];
        var data = {};
        var queryTerm = null;
        var queryTermWithQuotes = null;
        var journalDisplayName = null;
        var currentJournalDisplayName = null;
        var bookDisplayName = null;
        var isBookSearch = false;
        var isJournalSearch = false;
        var advancedQueryBuilderEnabled = false;

        searchTerm = $('#advancedSearchQueryTerm').val();
        advancedQueryBuilderEnabled = $('#queryBuilder').length;

        if (!advancedQueryBuilderEnabled && (searchTerm == null || searchTerm == '')) {
            alert('Please enter a term to search');
            return;
        } else if (!advancedQueryBuilderEnabled && searchTerm.length > parseInt(textCharectorLimit)) {
            alert('Please enter a term between 1 to ' + textCharectorLimit + ' characters.');
            return;
        }
        $('#advancedSearch input.anyAllExact[type=radio]').each(function () {
            if (this.checked) {
                radioCheck = $(this).attr('id');
            }
        });

        queryTermWithQuotes = '"' + searchTerm + '"';

        switch (radioCheck) {
            case '1':
                data.hd = 'advancedAny';
                queryTerm = searchTerm;                 //Any does NOT need quotes around the term ("q").
                break;
            case '2':
                data.hd = 'advancedAll';
                queryTerm = searchTerm;                 //All does NOT need quotes around the term ("q")
                break;
            case '3':
                queryTerm = queryTermWithQuotes;        //exact phrase need quotes around the term ("q")
                break;
            default:
        }

        //Apply relevancy parameter to all the options:
        //No encodeURIComponent here: $.param() encodes; doing both yields %2522 and Solr matches nothing.
        data.q = $.trim(queryTerm);
        //data.exPrm_qqq = "{!payload_score f=Tags func=max v=q$}" + queryTermWithQuotes;

        var authorTextValue = $('#advancedSearch #authorName').val();
        if (authorTextValue != null && authorTextValue != '') {
            //data.fd_Authors = authorTextValue;

            //In view of the Author boosting changes, passing author in the url as a querystring
            data.author = authorTextValue;
        }

        //Start and End Dates
        var $startInputKw = $('#startDateSemanticSearch');
        var $endInputKw = $('#endDateSemanticSearch');
        var inlineDateValidation = $endInputKw.data('enableInlineValidation') === true;

        if (inlineDateValidation) {
            // WCAG 3.3.1: a native <input type="date"> reports an EMPTY value for an incomplete
            // date (missing month/day or year-only). Detect partial entry via validity.badInput
            // and block it with an inline error BEFORE the empty-value check below — otherwise the
            // partial collapses to '' and the search runs unfiltered.
            var incompleteMessage = $endInputKw.data('errorIncompleteDate');

            if (SCM.SearchResults.hasIncompleteDateEntry($startInputKw[0])) {
                SCM.SearchResults.showInlineDateRangeError($startInputKw, incompleteMessage);
                return;
            }
            if (SCM.SearchResults.hasIncompleteDateEntry($endInputKw[0])) {
                SCM.SearchResults.showInlineDateRangeError($endInputKw, incompleteMessage);
                return;
            }

            startDate = $startInputKw.val();
            if (startDate !== '') {
                var endRaw = $endInputKw.val();
                if (endRaw === '') {
                    // Open-ended range: default the end date to today.
                    endDate = isoToday();
                    $endInputKw.val(endDate);
                } else {
                    endDate = endRaw;
                    if (new Date(endDate) < new Date(startDate)) {
                        SCM.SearchResults.showInlineDateRangeError($endInputKw, $endInputKw.data('errorBeforeStart'));
                        return;
                    }
                }
                data.rg_PublicationDate = startDate + ' TO ' + endDate;
            }

            SCM.SearchResults.clearInlineDateRangeError($startInputKw);
            SCM.SearchResults.clearInlineDateRangeError($endInputKw);
        } else {
            // Legacy (non-accessible) path — unchanged behavior for clients not opted in.
            startDate = $startInputKw.val();
            if (startDate != null && startDate !== '' && startDate !== 'mm/dd/yyyy') {
                if (isYearOnly(startDate)) {
                    startDate = updateYearOnlyToFullDate($startInputKw, true);
                } else if (!isValidDate(startDate)) {
                    alert('please enter valid start date');
                    return;
                }// if start date is specified and enddate is not specified, default the end date to current date
                if ($endInputKw.val() === '') {
                    $endInputKw.val(new Date().today());
                    endDate = $endInputKw.val();
                } else {
                    endDate = $endInputKw.val();
                    if (isYearOnly(endDate)) {
                        endDate = updateYearOnlyToFullDate($endInputKw, false);
                    } else {
                        var invertedDateRange = new Date(endDate) < new Date(startDate);
                        if (!isValidDate(endDate) || invertedDateRange) {
                            alert('please enter valid end date');
                            return;
                        }
                    }
                }
                data.rg_PublicationDate = startDate + ' TO ' + endDate;
            }
        }


        //''chkAdvancedSearchJournal
        $('#advancedSearch input.rbPublication[type=radio]').each(function () {
            if (this.checked) {
                isJournalSearch = $(this).attr('value') == 'J*' ? true : false;
                isBookSearch = $(this).attr('value') == 'B*' ? true : false;
            }
        });

        $('#advancedSearch .advancedSearchJournal:checked').each(function () {
            isJournalSearch = true;
            currentJournalDisplayName = $(this).attr('currentjournaldisplayname');
            journalDisplayName = $(this).attr('text');
            journalHistIds.push($(this).attr('value'));
            journalIds.push($(this).attr('jid'));
        });

        $('#advancedSearch .advancedSearchBook:checked').each(function () {
            isBookSearch = true;
            bookDisplayName = $(this).attr('text');
            bookIds.push($(this).attr('bid'));
        });

        doAdvancedQbSearch(data);

        var redirectUrl = '/search-results?' + $.param(data);
        if (isJournalSearch) {
            var journalHistIdquery = journalHistIds.join(' OR ');
            var journalIdquery = journalIds.join(' OR ');
            redirectUrl = redirectUrl + '&restypeid=3';
            if (journalHistIds.length == 1) {
                var journalFacetName = encodeURIComponent($.trim(journalDisplayName));
                if (journalDisplayName == currentJournalDisplayName) {
                    journalQuery = '&fl_JournalID=' + journalIdquery + '&f_JournalDisplayName=' + journalFacetName;
                } else {
                    journalQuery = '&fl_JournalID=' + journalIdquery + '&f_JournalDisplayName=' + encodeURIComponent($.trim(currentJournalDisplayName)) + '&fd_LegacyJournalDisplayName=' + journalFacetName;
                }
                redirectUrl = redirectUrl + journalQuery;
            } else if (journalHistIds.length > 1) {
                //multiple journals selected; some could be Legacy and some could be Current
                //Pass JournalHistID because the list could contain some legacy journals.
                var journalHistIdQueryString = '&fl_JournalHistID=' + journalHistIdquery;

                redirectUrl = redirectUrl + journalHistIdQueryString;
            } else if (journalHistIds.length == 0) {
                //If all journals, tag this to querystring
                redirectUrl = redirectUrl + '&allJournals=1';
            }

            // alert(redirectUrl);
        }

        //TI-16370 - WKHL has Book Content only and the publicationType option (Journals/Books) section is hidden. So isBookSearch is not set at this point.
        //This version is currently used by ASHA, AJOT, and WKHL. ASHA and AJOT have journal only content. This should be okay for now!
        isBookSearch = solrBookSearchScope != null && solrBookSearchScope != '' && !isJournalSearch;

        if (isBookSearch) {
            redirectUrl = redirectUrl + getBookQueryParams(bookIds, bookDisplayName);
        }

        redirectUrl = AppendSubscriptionParameterToUrl(redirectUrl);
        redirectUrl = AddQueryStringParams(redirectUrl);

        var searchSiteUrl = StripTrailingCharacters($('#hfSiteURL').val(), UrlStripTrailingCharactersPattern);
        window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&searchType=advanced';
    }

    //Enter key -- Advanced Semantic Search
    $('#advancedSearchQueryTerm').keydown(function (e) {
        if (e.keyCode == 13) {
            doAdvancedKeyWordSearch();
        }
    });

    //Semantic Search Click
    $(document).on('click', '#btnAdvancedSearch, #btnAdvancedSearchTop, .js-qb-execute-search', function () {
        doAdvancedKeyWordSearch(); //advancedKeyWordSearch
    });

    // ----
    // Author Search
    // ----

    //Author Search
    function doAdvancedAuthorSearch() {

        var startDate = null;
        var endDate = null;
        var searchTerm = null;
        var journalIds = [];
        var bookIds = [];
        var journalHistIds = [];
        var journalItems = [];
        var data = {};
        var journalDisplayName = null;
        var currentJournalDisplayName = null;
        var bookDisplayName = null;
        var isBookSearch = false;
        var isJournalSearch = false;


        searchTerm = $('#advancedAuthorSearchQueryTerm').val();
        if (searchTerm == null || searchTerm == '') {
            alert('Please enter a term to search');
            return;
        } else if (searchTerm.length > parseInt(textCharectorLimit)) {
            alert('Please enter a term between 1 to ' + textCharectorLimit + ' characters.');
            return;
        } else {
            //Author relevancy/boosting changes
            data.author = $.trim(searchTerm);
            data.q = $.trim(searchTerm);
            //data.fd_Authors = searchTerm;
        }

        //Start and End Dates

        startDate = $('#startDateAuthor').val();
        //endDate = $('#endDateAuthor').val() == '' ? Date.now().toString : $('#endDateAuthor').val();
        if (startDate != null && startDate != '' && startDate != 'mm/dd/yyyy') {
            if (isYearOnly(startDate)) {
                startDate = updateYearOnlyToFullDate($('#startDateAuthor'), true);
            }

            if (!isValidDate(startDate)) {
                alert('please enter valid start date');
                return;
            }

            if ($('#endDateAuthor').val() === '') {
                $('#endDateAuthor').val(new Date().today());
                endDate = $('#endDateAuthor').val();
            } else {
                endDate = $('#endDateAuthor').val();
                if (isYearOnly(endDate)) {
                    endDate = updateYearOnlyToFullDate($('#endDateAuthor'), false);
                }
            }

            if (!isValidDate(endDate) || new Date(endDate) < new Date(startDate)) {
                alert('please enter valid end date');
                return;
            }

            data.rg_PublicationDate = startDate + ' TO ' + endDate;
        }

        $('.advancedAuthorSearch input.rbPublication[type=radio]').each(function () {
            if (this.checked) {
                isJournalSearch = $(this).attr('value') == 'J*' ? true : false;
                isBookSearch = $(this).attr('value') == 'B*' ? true : false;
            }
        });

        $('.advancedAuthorSearch .advancedSearchJournal:checked').each(function () {
            isJournalSearch = true;
            currentJournalDisplayName = $(this).attr('currentjournaldisplayname');
            journalDisplayName = $(this).attr('text');
            journalHistIds.push($(this).attr('value'));
            journalIds.push($(this).attr('jid'));
        });
        $('#advancedSearch #chkAdvancedSearchBook:checked').each(function () {
            isBookSearch = true;
            bookDisplayName = $(this).attr('text');
            bookIds.push($(this).attr('bid'));
        });

        var redirectUrl = '/search-results?' + $.param(data);
        if (isJournalSearch) {
            var journalHistIdquery = journalHistIds.join(' OR ');
            var journalIdquery = journalIds.join(' OR ');
            redirectUrl = redirectUrl + '&restypeid=3';
            if (journalHistIds.length == 1) {
                var journalFacetName = encodeURIComponent($.trim(journalDisplayName));
                if (journalDisplayName == currentJournalDisplayName) {
                    journalQuery = '&fl_JournalID=' + journalIdquery + '&f_JournalDisplayName=' + journalFacetName;
                } else {
                    journalQuery = '&fl_JournalID=' + journalIdquery + '&f_JournalDisplayName=' + encodeURIComponent($.trim(currentJournalDisplayName)) + '&fd_LegacyJournalDisplayName=' + journalFacetName;
                }
                redirectUrl = redirectUrl + journalQuery;
            } else if (journalHistIds.length > 1) {
                //multiple journals selected; some could be Legacy and some could be Current
                //Pass JournalHistID because the list could contain some legacy journals.
                var journalHistIdQueryString = '&fl_JournalHistID=' + journalHistIdquery;

                redirectUrl = redirectUrl + journalHistIdQueryString;
            } else if (journalHistIds.length == 0) {
                //If all journals, tag this to querystring
                redirectUrl = redirectUrl + '&allJournals=1';
            }

            // alert(redirectUrl);

        }
        if (isBookSearch) {
            redirectUrl = redirectUrl + getBookQueryParams(bookIds, bookDisplayName);
        }

        redirectUrl = AppendSubscriptionParameterToUrl(redirectUrl);

        var searchSiteUrl = StripTrailingCharacters($('#hfSiteURL').val(), UrlStripTrailingCharactersPattern);
        window.location.href = window.location.protocol + '//' + searchSiteUrl + redirectUrl + '&searchType=advanced';
    }

    //Author Search Click
    $(document).on('click', '#btnAdvancedAuthorSearch, #btnAdvancedAuthorSearchTop', function () {
        doAdvancedAuthorSearch();
    });


    //Enter key -- Advanced Author Search
    $('#advancedAuthorSearchQueryTerm').keydown(function (e) {
        if (e.keyCode == 13) {
            doAdvancedAuthorSearch();
        }
    });

    // ----
    // DOI Search
    // ----

    //DOI Keypress
    $('#Doi').on('keydown', function (e) {
        if (e.keyCode == 13) {
            doDoiSearch();
        }
    });

    $('#btnDoiSearch').on('click', function () {
        doDoiSearch();
    });

    function validateDoi() {
        var doi = $('#Doi').val().trim();

        if (doi == null || doi == '') {
            alert('Please enter a DOI to search.');
            return false;
        }
        return true;
    }
    //Doi redirect
    function doDoiSearch() {
        var doi = $('#Doi').val().trim();
        var doiValidated = validateDoi();

        if (doiValidated) {
            var myobj = { 'doi': doi };
            $.ajax({
                type: 'POST',
                url: '/Solr/DoiSearch/search',
                data: myobj,
                success: function (results) {
                    if (results == false) {
                        alert('Invalid DOI. Please enter a valid DOI');
                    }
                },
                error: function () {
                    alert('There was a problem with your request. Please try again later');
                }
            });
        }
        else {
            alert('Please enter a Doi to search');
            return;
        }
    }

    // ----
    // Book Query
    // ----
    function getBookQueryParams(bookIds, bookDisplayName) {
        var bookQueryString = '&restypeid=1';
        var bookIdQuery = bookIds.join(' OR ');

        if (SCM.AdvancedSearch.configSettings.preSelectSingleBookFacet == 'true' && bookIds.length === 1) {
            bookQueryString = bookQueryString + '&f_BookDisplayName=' + encodeURIComponent($.trim(bookDisplayName)) + '&fl_BookID=' + bookIdQuery;
        } else if (bookIds.length > 0) {
            bookQueryString = bookQueryString + '&fl_BookID=' + bookIdQuery;
        } else if (bookIds.length === 0) {
            bookQueryString = bookQueryString + '&allBooks=1';
        }

        return bookQueryString;
    }

    // ---- Advanced Query Builder 

    var qbAddTerm = function () {
        var template = $('#js_qb_term_template').html();
        var list = $(this).closest('.js_qb_group').find('.js_qb_terms_list');
        list.append(template);
    };

    var initializeQbAddTermsButton = function () {
        $(document).on('click', '.js_qb_add_term', qbAddTerm);
    };

    function initializeQbClearTermButtons() {
        $(document).on('click', '.js_qb_clear_term', qbClearTerm);
    }

    function initializeShowOptionalFieldsButton() {
        $('.js-optional-fields-toggle').on('click', toggleOptionalFieldsSectionExpansion);
    }

    function qbClearTerm() {
        const $Term = $(this).closest('.query-term');
        qbClearTermFields($Term);
    }

    function qbClearTermFields(parentElement) {
        if (!parentElement || !parentElement.length) {
            return;
        }

        parentElement.find('select').each(function () {
            this.selectedIndex = 0;
        });
        parentElement.find('input[type="text"]').val('');
        parentElement.find('input[type="checkbox"]').prop('checked', false);
    }

    function toggleOptionalFieldsSectionExpansion() {
        const $ToggleButton = $(this);
        const wasExpanded = $ToggleButton.attr('aria-expanded') === 'true';
        const willBeExpanded = !wasExpanded;

        // Update aria-expanded to the new state
        $ToggleButton.attr('aria-expanded', willBeExpanded.toString());

        // Update the label text based on the new state
        const expandedText = $ToggleButton.data('expandedText') || 'Hide optional fields';
        const collapsedText = $ToggleButton.data('collapsedText') || 'Show optional fields';
        $ToggleButton
            .find('.js-optional-fields-label')
            .text(willBeExpanded ? expandedText : collapsedText);

        // Toggle the section visibility
        const SectionId = $ToggleButton.attr('aria-controls');
        const $OptionalFieldsSection = $('#' + SectionId);
        $OptionalFieldsSection.toggleClass('hide', !willBeExpanded);

        // Toggle the arrow icon direction
        toggleArrowIconDirection($ToggleButton);
    }

    function toggleArrowIconDirection(toggleButton) {
        const $Icon = toggleButton.find('.js-abstract-toggle-icon');
        const ToggleIconClass = $Icon.data('icon-class');
        const DownArrowClass = `${ToggleIconClass}-down`;
        const UpArrowClass = `${ToggleIconClass}-up`;

        $Icon.toggleClass(DownArrowClass);
        $Icon.toggleClass(UpArrowClass);
    }

    $(document).on('click', '.js_qb_add_group', function () {
        var template = $('#js_qb_group_template').html();
        var list = $('#js_qb_groups');
        list.append(template);
    });

    function createAdvancedQbJsonObject() {
        var jsonObj = [];
        //for each group
        $('#js_qb_groups .js_qb_group').each(function () {

            var group = {};
            var $thisGroup = $(this);
            // add conditional to the group (if exists)
            $thisGroup.children('.row').children('.js_qb_data').each(function () {
                var $thisGroupData = $(this);
                var elementTitle = $thisGroupData.attr('data-qb-json-element');
                group[elementTitle] = $thisGroupData.val();
            });

            var terms = [];
            // for each term in the group
            $thisGroup.find('.js_qb_term').each(function () {

                var term = {};
                // for each data element in the term
                $(this).find('.js_qb_data').each(function () {
                    var $thisTermData = $(this);
                    var elementTitle = $thisTermData.attr('data-qb-json-element');

                    if (elementTitle === 'exactMatch') {
                        term[elementTitle] = $thisTermData.is(':checked');
                    }
                    else {
                        term[elementTitle] = $thisTermData.val();
                    }
                });

                // only add the term if there was a value entered
                if (term.input && term.input.length) {
                    terms.push(term);
                }
            });

            // only add the group is there are terms in it
            if (terms.length) {

                // ensures that the first term in a group does not contain the conditon property
                if (terms[0].condition) {
                    delete terms[0].condition;
                }

                group['terms'] = terms;
                jsonObj.push(group);
            }
        });

        // ensures that the first group in the obj does not contain the condition property
        if (Object.keys(jsonObj).length) {
            if (jsonObj[0].condition) {
                delete jsonObj[0].condition;
            }
        }

        return jsonObj;
    }

    // Returns the stringified Json, or empty string
    function doAdvancedQbSearch(queryStringData) {
        var qbJson = createAdvancedQbJsonObject();

        saveQbData();
        // Verify that the search contains a group, otherwise assume null search
        if (Object.keys(qbJson).length) {
            queryStringData.cqb = JSON.stringify(qbJson);
        }
    }

    function saveQbData() {
        if (!sessionStorage)
            return;

        var queryBuilderExists = $('#queryBuilder').length;
        var html = $('#queryBuilder').html();
        if (queryBuilderExists && html.length) {
            sessionStorage.setItem('querybuilder_html', JSON.stringify(html));
        }
    }

    $(document).on('click', '.js-advanced-search-reset', function (event) {
        SCM.SearchResults.clearInlineDateRangeError($('#startDateSemanticSearch'));
        SCM.SearchResults.clearInlineDateRangeError($('#endDateSemanticSearch'));
        clearQbSearch(event);
    });

    function clearQbSearch(event) {
        if ($('#hfPreventPageRefreshOnClearSearch').val()?.toLowerCase() === 'true') {
            const TargetId = $(event.currentTarget).data('targetId');
            const $Target = TargetId ? $('#' + TargetId) : null;
            qbClearTermFields($Target);
            return;
        }

        clearStorageAndRefreshPage()
    }

    function clearStorageAndRefreshPage() {
        sessionStorage.removeItem('querybuilder_html');

        // if the URL contains a ?, get rid of it; else, just reload
        if (window.location.href.indexOf('?') >= 0) {
            window.location.href = window.location.href.split('?')[0];
        } else {
            window.location.reload();
        }
    }

    //urlParam function to replace URLSearchParams
    function urlParam(name, queryString) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(queryString);
        return results && results.length > 1
            ? decodeURI(results[1].toString())
            : '';
    }

    function populateAdvancedSearchFromUrl() {

        var queryString = window.location.href.split('?')[1] || '';
        if (queryString) {
            queryString = decodeURIComponent(queryString.replace(/\+/g, ' '));
            populateQueryBuilderSearch(queryString);
            populateDateRangeSearch(queryString);
            populatePublicationSearch(queryString);
        }
    }

    function populateQueryBuilderSearch(queryString) {
        var strJson = urlParam('cqb', queryString);
        if (strJson) {
            var qbJson = JSON.parse(strJson);

            // Add enough groups to hold everything on the page            
            var groupsToAdd = Object.keys(qbJson).length - 1;
            for (var i = 0; i < groupsToAdd; i++) {
                $('.js_qb_add_group').click();
            }

            // For each group
            for (var i = 0; i < Object.keys(qbJson).length; i++) {
                var group = qbJson[i];
                var groupElement = $('#js_qb_groups .js_qb_group').eq(i);

                if (group.condition) {
                    groupElement.find('select[data-qb-json-element="condition"]').val(group.condition);
                }

                // Add enough terms for the group
                var termsToAdd = group.terms.length - 2;
                for (var j = 0; j < termsToAdd; j++) {
                    groupElement.find('.js_qb_add_term').click();
                }


                // Populate the terms
                for (var j = 0; j < group.terms.length; j++) {
                    var term = group.terms[j];
                    var termElement = groupElement.find('.js_qb_term').eq(j);

                    if (term.condition) {
                        termElement.find('select[data-qb-json-element="condition"]').val(term.condition);
                    }

                    termElement.find('select[data-qb-json-element="filter"]').val(term.filter);
                    termElement.find('input[data-qb-json-element="input"]').val(term.input);

                    if (term.exactMatch) {
                        termElement.find('input[data-qb-json-element="exactMatch"]').click();
                    }
                }
            }
        } else {
            restoreQbData();
        }
    }

    function populateDateRangeSearch(queryString) {
        var strPubDate = urlParam('rg_PublicationDate', queryString);
        if (strPubDate) {
            var dateRangeParamValue = strPubDate;
            var dates = dateRangeParamValue.split(/\sTO\s/);
            $('#startDateSemanticSearch').val(dates[0]);
            $('#endDateSemanticSearch').val(dates[1]);
        }
    }

    function populatePublicationSearch(queryString) {
        // if referring url has a facet parameter on publication, then we need to ignore all other publication parameters like journalid or historical id
        // because facet parameter can only exists on single publication.
        var facetPublicationParameterValue = urlParam('f_JournalDisplayName', queryString);
        if (facetPublicationParameterValue) {
            handleSearchFacetPublication(facetPublicationParameterValue);
        } else {
            handleOnlyOnePublication(queryString);
            handleMoreThanOnePublication(queryString);
        }        
    }

    function handleOnlyOnePublication(queryString) {
        var strJourID = urlParam('fl_JournalID', queryString);
        if (strJourID) {
            var journalIdParamValue = strJourID;
            $('.advancedSearchJournal[jid="' + journalIdParamValue + '"]').click();
        }

    }

    function handleMoreThanOnePublication(queryString) {
        var strJourIDs = urlParam('fl_JournalHistID', queryString);
        if (strJourIDs) {
            var journalIdsParamValue = strJourIDs;
            var journalIds = journalIdsParamValue.split(/\sOR\s/);

            journalIds.forEach(function (id) {
                $('.advancedSearchJournal[value="' + id + '"]').click();
            });
        }
    }

    function handleSearchFacetPublication(facetParameterValue) {       
        if (facetParameterValue) {
            $('.advancedSearchJournal[currentjournaldisplayname="' + facetParameterValue + '"]').click();
        }        
    }
    initializeQbAddTermsButton();
    initializeQbClearTermButtons();
    initializeShowOptionalFieldsButton();
    populateAdvancedSearchFromUrl();
    // ---- END Advanced Query Builder

    // ----
    // Expand and Collapse Sections
    // ----
    // Expand and collapse sections
    $(document).on('click', '.toggle-expanded', function () {
        $(this).parents('.search-module').toggleClass('collapsed').toggleClass('expanded');
        var $filterToggleButton = $(this).find('.filter-toggle');
        $filterToggleButton.attr('aria-expanded', $filterToggleButton.attr('aria-expanded') === 'true' ? 'false' : 'true');
    });



}); // END $(document).ready()





// ----
// Datepicker Keyboard Adjustments
// ----
// This prevents the form submitting when pressing enter while on the datepicker
$(function () {
    try {


        $('#startDateSemanticSearch').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            // When inline validation is on, year-only input must be rejected on submit (WCAG 3.3.1),
            // so it is left intact here rather than auto-completed to 01/01.
            if (e.which == 13 && $(this).data('enableInlineValidation') !== true) {
                var startDateSemanticSearch = $('#startDateSemanticSearch').val();
                if (isYearOnly(startDateSemanticSearch)) {
                    updateYearOnlyToFullDate($('#startDateSemanticSearch'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#endDateSemanticSearch').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            // When inline validation is on, year-only input must be rejected on submit (WCAG 3.3.1),
            // so it is left intact here rather than auto-completed to 12/31.
            if (e.which == 13 && $(this).data('enableInlineValidation') !== true) {
                var endDateSemanticSearch = $('#endDateSemanticSearch').val();
                if (isYearOnly(endDateSemanticSearch)) {
                    updateYearOnlyToFullDate($('#endDateSemanticSearch'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#startDateAuthor').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var startDateAuthor = $('#startDateAuthor').val();
                if (isYearOnly(startDateAuthor)) {
                    updateYearOnlyToFullDate($('#startDateAuthor'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        $('#endDateAuthor').on('keydown', function (e) {
            // http://stackoverflow.com/questions/15235499/jquery-ui-datepicker-prevent-enter-selecting-when-readonly
            if (e.which == 13) {
                var endDateAuthor = $('#endDateAuthor').val();
                if (isYearOnly(endDateAuthor)) {
                    updateYearOnlyToFullDate($('#endDateAuthor'), true);
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        });

        // Native date inputs ([type=date]) have no jQuery UI datepicker, so the arrow-key
        // calendar navigation below does not apply to them.
        var $dateFields = $('#startDateSemanticSearch, #endDateSemanticSearch, #startDateAuthor, #endDateAuthor').not('[type="date"]');
        $dateFields.on('keydown', function (e) {
            if (e.ctrlKey || e.metaKey || e.altKey) {
                return;
            }
            var $calendar = $(this).datepicker('widget');
            if (!$calendar.length || !$calendar.is(':visible')) {
                return;
            }
            var dayOffset;
            switch (e.which) {
                case 37: dayOffset = -1; break;
                case 39: dayOffset = 1; break;
                case 38: dayOffset = -7; break;
                case 40: dayOffset = 7; break;
                default: return;
            }
            var instance = $.datepicker._getInst(this);
            if (instance) {
                instance._keyEvent = true;
            }
            $.datepicker._adjustDate(this, dayOffset, 'D');
            e.preventDefault();
        });

    } catch (e) { }
});
